// firebase
import db from "@/firebase/init";
import firebase from "firebase";
// moment
import moment from "moment";
moment.locale("pt-br");
// utils
import presentAlert from "@/services/general/rate-app.js";
// services
import store from '@/utils/store.js'

const doneMealService = async (params) => {
    const {
        dishId,
        date,
        meal,
        mealplanId,
        doneStatus,
    } = params;
    console.log('params');
    console.log(params);
    // get user info
    const userId = store.state.user.uid;
    const profileId = store.state.profile.id;
    let dishesDone = store.state.profile.data.dishesDone;
    if (!dishesDone) {
        dishesDone = [];
    }
    let level = store.state.profile.data.level;
    let points = store.state.profile.data.points;
    let platform = store.state.profile.data.platform;
    let reviewed = store.state.profile.data.reviewed;
    // calculate points
    let numPoints;
    if (meal === "breakfast") {
        numPoints = 2;
    } else if (meal === "morningSnack") {
        numPoints = 1;
    } else if (meal === "lunch") {
        numPoints = 4;
    } else if (meal === "afternoonSnack") {
        numPoints = 1;
    } else if (meal === "dinner") {
        numPoints = 3;
    } else if (meal === "supper") {
        numPoints = 1;
    } else {
        //
    }

    console.log('numPoints: ', numPoints);

    // update db
    if (doneStatus) {
        console.log('doneStatus true');
        for (let i = 0; i < dishesDone.length; i++) {
            if (dishesDone[i].id === dishId) {
                dishesDone.splice(i, 1);
            }
        }
        points -= numPoints;
        await db.collection("mealplans")
            .doc(mealplanId)
            .update({
                done: false
            });
        await db.collection("dishes")
            .doc(dishId)
            .update({
                doneBy: firebase.firestore.FieldValue.arrayRemove(userId)
            });
        await db.collection("users")
            .doc(profileId)
            .update({
                dishesDone: dishesDone,
                points: points,
                level: level
            });
    } else {
        console.log('doneStatus false');
        const random = Math.random() * 100;
        console.log(random);
        if (random < 50) {
            console.log('reviewed: ');
            console.log(reviewed);
            if (!reviewed) {
                const alertParams = {
                    header: "Review",
                    message: "Está gostando do Updiet?",
                    profileId: profileId,
                    platform: platform
                };
                presentAlert(alertParams);
            }
        }
        const dishObj = {
            id: dishId,
            date: date
        };
        dishesDone.push(dishObj);
        points += numPoints;
        await db.collection("mealplans")
            .doc(mealplanId)
            .update({
                done: true
            });
        await db.collection("dishes")
            .doc(dishId)
            .update({
                doneBy: firebase.firestore.FieldValue.arrayUnion(userId)
            });
        await db.collection("users")
            .doc(profileId)
            .update({
                dishesDone: dishesDone,
                points: points,
                milestoneFirstMeal: true
            });
        store.state.profile.data.milestoneFirstMeal = true;
    }
    store.state.profile.data.dishesDone = dishesDone;
    store.state.profile.data.points = points;
    store.state.profile.data.level = level;
    return numPoints;
}

export default doneMealService;